'use client';

import { useDecisions } from '@libs/common-next';

export function OptexHomepageBiaGuest() {
    const { homepage_bia_guest } = useDecisions();

    if (!homepage_bia_guest) return null;

    return <div className="optex_homepage_bia" data-testid="optex_homepage_bia" />;
}
